<div class="container-fluid">
    <div class="row fondoAmarillo">
        <div class="col-lg-2">
            <img src="assets/img/auri.png" height="60px">
        </div>
        <div class="col-lg-8">
            <br>
            <p class="center blanco">¡Bienvenido 
                <!-- <span class="bold">{{dataUsuario.first_name}}</span>! -->
            </p>
        </div>
        <div class="col-lg-2">
            <br>
            <p><a class="blanco bold" (click)="closeSesion()">Cerrar Sesión</a></p>
        </div>
    </div>
    <br><br>
    <div class="row">
        <div class="col-3">
            <a href="seleccionar-detalles/{{currentCliente}}/{{currentGrupo}}/{{currentPaquete}}" class="bold negro">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
                  </svg> Regresar
            </a>
        </div>
        <div class="col-6">
            <h5 class="center">¡Por favor elige un marco!</h5>
        </div>
    </div>

    <div class="row">
        <br>
        <br>
        <div class="row">
            
            <div *ngFor="let moldura of molduras" class="col-lg-3 col-sm-3 col-md-3 col-6">
                <div *ngIf="moldura.imagen; else imagenAuri4">
                    <img src="{{environment}}{{moldura.imagen}}" width="100%">
                </div>
                <ng-template #imagenAuri4>
                    <img src="assets/img/auri.png" width="100%"><br>
                </ng-template>

                <p class="center">{{moldura.nombre}}</p>
                <p class="text-center">
                    <button class="btn btn-primary fondoAmarillo border0" style="border:0px;" (click)="agregarMoldura(moldura.id)">Elegir Marco</button><br><br>
                </p>
            </div>
        </div>
    </div>
</div>